import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { LEGACY_TRIP_ITEM_RECEIPT_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

/**
 * /trip-receipt/7601872074639
 */

export class LegacyTripItemReceiptController implements Controller {
  public readonly bundles = [];
  public readonly pageId = 'page.Trip.ItemReceipt,U,80';
  public readonly routeName = 'legacy-trip-item-receipt';
  public readonly exact = true;
  public readonly path = '/trip-receipt/:tripItemId([a-z0-z-]+)';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trip-item-receipt" */ 'views/trip-item-receipt-view')
  );
  public readonly pageName = 'page.Trip.ItemReceipt';
  public readonly clickstreamPageName = 'Trip Item Receipt';

  public shouldStreamResponse(): boolean {
    return false;
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, LEGACY_TRIP_ITEM_RECEIPT_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to legacy-trips-item-receipt-controller'
    });

    return Promise.resolve();
  }
}
